








































import  {Component} from "vue-property-decorator";
import DatenschutzFaTab from "./Generic/DatenschutzFaTab.vue";
import RadioCheckbox from "@/components/radio-checkbox/RadioCheckbox.vue";

@Component({
    components: {RadioCheckbox}
})
export default class DatenschutzFa6Gesamtabwaegung extends DatenschutzFaTab {


}
